import { render, staticRenderFns } from "./CreateEnrolmentModal.vue?vue&type=template&id=8617bef8&scoped=true&"
import script from "./CreateEnrolmentModal.vue?vue&type=script&lang=js&"
export * from "./CreateEnrolmentModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateEnrolmentModal.vue?vue&type=style&index=0&id=8617bef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8617bef8",
  null
  
)

export default component.exports